<template>
  <div>
    <span class="tabTitle">外部带入条件</span>
    <search-form-in-tab :searchModel="searchModel" class="searchFromInTab"></search-form-in-tab>
    <div class="searchDiv">
      <span class="timeTitle">预测时间</span>
      <a-month-picker v-model="searchModel.forecastStartDate" :disabled-date="disabledDateStart" placeholder="开始时间" @openChange="handleStartOpenChange"/>
      <a-month-picker v-model="searchModel.forecastEndDate" :disabled-date="disabledDateEnd" :open="endOpen" placeholder="结束时间" @openChange="handleEndOpenChange"/>
      <a-button type="primary" class="forecastBtn" @click="forecast(true)" :loading="loading">预测</a-button>
      <a-button @click="reset" class="forecastBtn">重置</a-button>
      <!--      <a-button @click="changeTime('thisYear')" class="forecastBtn">本年</a-button>-->
      <!--      <a-button @click="changeTime('threeYear')" class="forecastBtn">未来三年</a-button>-->
      <!--      <a-button @click="changeTime('fiveYear')">未来五年</a-button>-->
      <a-select
        style="width: 160px"
        :allowClear="true"
        placeholder="请选择未来时间"
        v-model="searchTime"
        @change="changeTime">
        <a-select-option v-for="(item, index) in timeList" :value="item.id" :key="index">
          {{ item.label }}
        </a-select-option>
      </a-select>
    </div>
    <span class="tabTitle">预测折旧结果</span>
    <span class="time">{{ showStartDate }}  -  {{ showEndDate }}</span>
    <div class="predictTheOutcome">
      <div class="left">
        <span class="title">当前预测折旧总额:</span>
        <span class="money">{{ predictTheOutcomeNum | moneyFormat }}万元</span>
      </div>
      <div class="right">
        <span class="title">资产统计条数:</span>
        <span class="money" v-if="allAssetPurchasePrice">{{ allAssetPurchasePrice }}条</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { getAssetForecast, getAssetTableData } from '@/api/assetLedger'
import searchFormInTab from '@/views/assetLedger/modules/echartsModules/searchFormInTab'
import { mapGetters } from 'vuex'
export default {
  name: 'SearchTab',
  props: ['searchModel'],
  components: {
    searchFormInTab
  },
  data () {
    return {
      predictTheOutcomeNum: 0,
      loading: false,
      mode1: ['month', 'month'],
      endOpen: false,
      showStartDate: null,
      showEndDate: null,
      allAssetPurchasePrice: '',
      // 搜索时间
      searchTime: undefined,
      // 未来一到十年(1-10)
      timeList: [
        { id: '本年', label: '本年' },
        { id: '1', label: '未来一年' },
        { id: '2', label: '未来二年' },
        { id: '3', label: '未来三年' },
        { id: '4', label: '未来四年' },
        { id: '5', label: '未来五年' },
        { id: '6', label: '未来六年' },
        { id: '7', label: '未来七年' },
        { id: '8', label: '未来八年' },
        { id: '9', label: '未来九年' },
        { id: '10', label: '未来十年' }
      ]
    }
  },
  filters: {
    // 金额格式化
    moneyFormat (value) {
      if (value) {
        return value.toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')
      } else {
        return '0.00'
      }
    }
  },
  computed: {
    ...mapGetters(['assetEchartsCompanyId', 'assetEchartsAnlkl'])
  },
  watch: {
    assetEchartsCompanyId (newValue) {
      // 调用防抖函数
      this.debouncedGetData()
    },
    assetEchartsAnlkl (newValue) {
      // 调用防抖函数
      this.debouncedGetData()
    }
  },
  created () {
    // 初始化时创建对于getData函数的防抖
    this.debouncedGetData = this.debounce(this.forecast, 200)
  },
  mounted () {
  },
  methods: {
    // 防抖
    debounce (fn, delay) {
      let timer = null
      return function () {
        const context = this
        const args = arguments
        clearTimeout(timer)
        timer = setTimeout(function () {
          fn.apply(context, args)
        }, delay)
      }
    },
    // 设置a-range-picker的开始时间可选范围
    disabledDateStart (current) {
      if (this.searchModel.forecastEndDate) {
        // 当前时间---结束时间
        return current && current < moment().subtract(1, 'days').endOf('day') || current > moment(this.searchModel.forecastEndDate).endOf('day')
      } else {
        // 当前时间之后
        return current && current < moment().subtract(1, 'days').endOf('day')
      }
    },
    // 设置a-range-picker的结束时间可选范围
    disabledDateEnd (current) {
      if (this.searchModel.forecastStartDate) {
        // 开始时间之后
        return current && current < moment(this.searchModel.forecastStartDate).subtract(1, 'days').endOf('day')
      } else {
        // 当前时间之后
        return current && current < moment().subtract(1, 'days').endOf('day')
      }
    },
    // 控制结束时间弹窗的显示
    handleStartOpenChange (open) {
      if (!open) {
        this.endOpen = true
      }
    },
    // 控制结束时间弹窗的显示
    handleEndOpenChange (open) {
      this.endOpen = open
    },
    // 改变时间
    changeTime (type) {
      if (type) {
        if (type === '本年') {
          // start为当前月份的下一个月，end为当前年份的12月
          const start = moment().add(1, 'month').startOf('month')
          const end = moment().endOf('year')
          this.searchModel.forecastStartDate = start
          this.searchModel.forecastEndDate = end
        } else {
          // 根据Number类型的type，来计算未来的1-10年，start为当前月份的下一个月，end为type年后的当前月份
          const start = moment().add(1, 'month').startOf('month')
          const end = moment().add(Number(type), 'years').add('month').startOf('month')
          this.searchModel.forecastStartDate = start
          this.searchModel.forecastEndDate = end
        }
      } else {
        // 清空开始时间和结束时间
        this.searchModel.forecastStartDate = null
        this.searchModel.forecastEndDate = null
      }
      this.$forceUpdate()
    },
    // 预测
    forecast (message) {
      // 判断是否选择了开始时间和结束时间
      if (!this.searchModel.forecastStartDate || !this.searchModel.forecastEndDate) {
        if (message) {
          this.$message.error('请选择预测时间')
        }
        return
      }
      this.$forceUpdate()
      const params = { ...this.searchModel }
      if (this.searchTime === '今天') {
        this.showStartDate = this.searchModel.forecastStartDate.format('YYYY-MM-DD')
        this.showEndDate = this.searchModel.forecastEndDate.format('YYYY-MM-DD')
        params.forecastStartDate = this.searchModel.forecastStartDate.format('YYYY-MM-DD')
        params.forecastEndDate = this.searchModel.forecastEndDate.format('YYYY-MM-DD')
      } else {
        this.showStartDate = this.searchModel.forecastStartDate.format('YYYY-MM')
        this.showEndDate = this.searchModel.forecastEndDate.format('YYYY-MM')
        params.forecastStartDate = this.searchModel.forecastStartDate.format('YYYY-MM')
        params.forecastEndDate = this.searchModel.forecastEndDate.format('YYYY-MM')
      }
      const delArr = ['current', 'showQuickJumper', 'showSizeChanger', 'pageSize', 'pageNum', 'pageSizeOptions', 'total', 'forecastDate', 'comid', 'deaktDate', 'aktivDate', 'zugdtDate', 'useDeptIdTab']
      delArr.forEach(item => {
        delete params[item]
      })
      const anlklList = []
      if (this.assetEchartsAnlkl.anlklList) {
        this.assetEchartsAnlkl.anlklList.forEach((item, index) => {
          if (item !== '资产分类' && (item.indexOf('0-0') === -1)) {
            anlklList.push(item)
          }
        })
      }
      if (anlklList.length > 0) {
        params.anlklList = anlklList
      }
      if (this.assetEchartsCompanyId.comid) {
        params.comidList = this.assetEchartsCompanyId.comid.filter(item => item !== '杭氧')
      }
      this.loading = true
      getAssetForecast(params).then(res => {
        if (res.status === 0) {
          if (res.data) {
            this.predictTheOutcomeNum = res.data.nafaz
          } else {
            this.predictTheOutcomeNum = 0
          }
          this.loading = false
        } else {
          this.$message.error(res.info.message)
          this.loading = false
        }
      }).catch(err => {
        this.$message.error(err.info.message)
        this.loading = false
      })
      getAssetTableData(params).then(res => {
        if (res.status === 0) {
          console.log(params)
          if (params.comidList.length === 0 || !params.hasOwnProperty('anlklList')) {
            this.allAssetPurchasePrice = 0
            return
          }
          this.allAssetPurchasePrice = String(res.data.total)
        } else {
          this.$message.error(res.info.message)
        }
      }).catch(err => {
        this.$message.error(err.info.message)
      })
    },
    reset () {
      this.searchModel.forecastStartDate = null
      this.searchModel.forecastEndDate = null
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped lang="less">
.searchFromInTab {
  margin-top: 12px;
}
.tabTitle {
  color: #333333;
  font-weight: bold;
}
.searchDiv {
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid #DDDDDD;
  .timeTitle {
    margin-right: 12px;
  }
  .searchTime {
    margin: 0 12px;
  }
  .forecastBtn {
    margin-right: 12px;
  }
}
.time {
  background: #1791FF19;
  border-radius: 3px;
  padding: 4px 8px;
  margin-left: 12px;
}
.predictTheOutcome {
  width: 100%;
  margin-top: 12px;
  padding: 15px 0;
  display: flex;
  justify-content: space-between;
  .left {
    width: calc(50% - 10px);
    background: rgba(8,64,159,0.1);
    padding: 16px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .right {
    width: calc(50% - 10px);
    background: rgba(8,64,159,0.1);
    padding: 16px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .title {
    color: #333333;
    font-weight: 400;
    font-size: 18px;
    margin-right: 14px;
  }
  .money {
    color: #1791FF;
    font-weight: 400;
    font-size: 18px;
  }
}
/deep/.ant-calendar-picker {
  margin-right: 12px;
}
</style>
